import React from 'react';

export class Error extends React.Component {

    render() {
        return <div className="error">
            oh no
        </div>
    }

}